import Router from './util/Router'
import common from './routes/common'
import pageTemplateDefault from './routes/page'
import singleCaseStudies from './routes/page'
import portfolio from './routes/portfolio'
import portefeuille from './routes/portfolio'
import home from './routes/home'
import demoHome from './routes/home'
import archive from './routes/archive'

//boardOfDirectors

import pageId701 from './routes/board-directors'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	common,
	pageTemplateDefault,
	singleCaseStudies,
	portfolio,
	portefeuille,
	home,
	demoHome,
	archive,
	pageId701,
})

/** Load Events */
routes.loadEvents()
